import React from 'react';

import type { DeliveryProductDetailsScreenProps } from '../../navigation/AppNavigation.props';
import { DeliveryProductDetails } from './components';

export const DeliveryProductDetailsScreen = ({
  navigation,
  route,
}: DeliveryProductDetailsScreenProps) => {
  const { addressId, productSlug } = route.params;

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag');
  }, [navigation]);

  return (
    <DeliveryProductDetails
      addressId={addressId}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
    />
  );
};
